import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchAllTrustScores } from "../../lib/api";

const TrustContext = createContext({ scores: {}, loading: true });

export const TrustProvider = ({ children }) => {
  const [scores, setScores] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const data = await fetchAllTrustScores();
      const map = {};
      (data.items || []).forEach((s) => { map[s.slug] = s; });
      setScores(map);
    } catch (e) {
      setScores({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <TrustContext.Provider value={{ scores, loading, refresh: load }}>
      {children}
    </TrustContext.Provider>
  );
};

export const useTrustScore = (slug) => {
  const { scores, loading } = useContext(TrustContext);
  return { score: scores[slug] || null, loading };
};
